import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Location } from "@angular/common";
import { Services } from '.';

@Injectable()
export class GuardService implements CanActivate {
    constructor(private router: Router,
        private location: Location,
        private cookieService: CookieService,
        protected svc: Services) { }

    canActivate(route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean {

        let currentUri = this.location.path();
        let uri = this.cookieService.get('uri');
        if (!currentUri.includes('acessoExterno?token')){
            if (!route.params.chaveAcesso.match(uri)) {
                this.svc.bnAlertService.alertaErro(`Erro`, `Já existe uma sessão em aberto, será necessário encerrar a sessão ativa para realizar um novo acesso.`);
                this.router.navigate(['sessaoExpirada']);
                return false;
            }
        }
        return true;
    }
}

